<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>groups</md-icon>
      </div>
      <h4 class="title">
        Tour Group
      </h4>
    </md-card-header>
    <md-card-content>
      <div class="md-layout" id="traveller-header">
        <div class="md-layout-item md-size-90">
          <h6>Travellers</h6>
        </div>
        <div class="md-layout-item md-size-10 text-right">
          <md-button
            class="md-icon-button md-dense md-primary md-round"
            @click="addTraveller"
          >
            <md-icon>add</md-icon>
            <md-tooltip md-direction="top"
              >Add a Traveller to this Booking</md-tooltip
            >
          </md-button>
        </div>

        <booking-add-traveller
          :showAddTravellerDialog="showAddTravellerDialog"
          :booking="booking"
          @new-traveller="newTraveller"
          @cancel="showAddTravellerDialog = false"
        />

        <booking-add-extra
          :showExtrasDialog="showExtrasDialog"
          :booking="booking"
          :traveller="selectedTraveller"
          @new-extra="newExtra"
          @cancel="showExtrasDialog = false"
        />
      </div>

      <template v-if="booking.travellers.length">
        <div
          v-for="traveller in booking.travellers"
          :key="traveller.id"
          class="md-layout md-alignment-middle-left traveller"
        >
          <div class="md-layout-item md-size-40 traveller-info">
            <!-- Traveller Info -->
            <div class="personal">
              <router-link
                class="traveller-name"
                :to="{
                  name: 'Customer Profile',
                  params: { id: traveller.user_info.id }
                }"
                >{{ traveller.user_info.full_name }}
              </router-link>
              <div>{{ traveller.user_info.email }}</div>
              <div>{{ traveller.user_info.cell_num }}</div>
            </div>

            <template v-if="booking.departure.tour.type.value == 'event'">
              <booking-ticket-info
                :booking="booking"
                :traveller="traveller"
                :ticketTypes="ticketTypes"
                @ticketSelected="ticketSelected"
                @priceOveride="departurePriceOveride"
              ></booking-ticket-info>
            </template>

            <template v-else>
              <div class="booking-price">
                <md-field class="" slot="inputs">
                  <label>Booking Price</label>
                  <md-input
                    v-model="traveller.departure_price"
                    v-on:change="evt => departurePriceOveride(traveller, evt)"
                    type="text"
                  ></md-input>
                  <md-icon class="price-info text-primary">
                    help
                    <md-tooltip md-direction="right"
                      >Set the
                      {{
                        booking.departure.tour.type.value == "event"
                          ? "Event"
                          : "Departure"
                      }}
                      price for {{ traveller.user_info.full_name }}</md-tooltip
                    >
                  </md-icon>
                </md-field>
              </div>
            </template>

            <div v-if="!isLeadBooker(traveller)" class="remove-traveller">
              <a href="#" @click.stop="removeTraveller(traveller)">
                Remove Traveller
                <md-icon>clear</md-icon>
              </a>
            </div>
          </div>

          <div class="md-layout-item md-size-60 extras">
            <div class="md-layout">
              <md-switch
                v-model="traveller.details_complete"
                v-on:change="setDetailsComplete(traveller)"
                >Customer Details Complete</md-switch
              >
            </div>
            <!-- Extras -->
            <div class="md-layout">
              <div class="md-layout-item md-size-90">
                <h6 v-if="traveller.extras.length">
                  Extras
                </h6>
                <h6 v-else>
                  No Extras have been assigned
                </h6>
              </div>
              <div class="md-layout-item md-size-10 text-right">
                <md-button
                  class="md-icon-button md-dense md-primary md-simple"
                  @click="addExtra(traveller)"
                >
                  <md-icon>add</md-icon>
                  <md-tooltip md-direction="top"
                    >Add an Extra for
                    {{ traveller.user_info.full_name }}</md-tooltip
                  >
                </md-button>
              </div>
            </div>

            <div
              v-for="extra in traveller.extras"
              :key="extra.id"
              class="md-alignment-middle-left extra"
            >
              <booking-traveller-extra
                :extra="extra"
                :traveller="traveller"
                @extraRemoved="extraRemoved"
                @extraUpdated="extraUpdated"
              />
            </div>
          </div>

          <div class="md-layout-item md-size-100 traveller-info">
            <collapse
              :collapse="['Travel Info']"
              icon="keyboard_arrow_down"
              color-collapse="primary"
            >
              <template slot="md-collapse-pane-1">
                <booking-traveller-travel-info
                  :traveller="traveller"
                  :booking="booking"
                  :transportModes="transportModes"
                />
              </template>
            </collapse>
          </div>
        </div>
      </template>
      <md-empty-state
        v-else
        md-label="Travellers..."
        md-description="No one has been booked on yet!"
      >
        <md-button class="md-primary md-raised" @click="addTraveller"
          >Add a Traveller to this Booking</md-button
        >
      </md-empty-state>
    </md-card-content>
  </md-card>
</template>

<script>
import bookingApi from "@/services/api/booking";
import departureApi from "@/services/api/departure";
import optionsApi from "@/services/api/options";
import { Collapse } from "@/components";

import BookingAddTraveller from "./BookingAddTraveller.vue";
import BookingAddExtra from "./BookingAddExtra.vue";
import BookingTravellerExtra from "./BookingTravellerExtra.vue";
import BookingTravellerTravelInfo from "./BookingTravellerTravelInfo.vue";
import BookingTicketInfo from "./BookingTicketInfo.vue";
import confirm from "@/helpers/deleteConfirm";
import _filter from "lodash/filter";

export default {
  props: ["booking"],

  data() {
    return {
      showAddTravellerDialog: false,
      showExtrasDialog: false,
      selectedTraveller: {
        extras: []
      },
      transportModes: [],
      ticketTypes: []
    };
  },

  components: {
    BookingAddTraveller,
    BookingAddExtra,
    BookingTravellerExtra,
    Collapse,
    BookingTravellerTravelInfo,
    BookingTicketInfo
  },

  computed: {},

  created() {
    optionsApi.transportModes().then(response => {
      this.transportModes = response.data;
    });
    departureApi
      .getDepartureTickets(this.booking.departure.id)
      .then(response => {
        this.ticketTypes = response.data.tickets;
      });
  },

  methods: {
    isLeadBooker(traveller) {
      return traveller.user_info.id == this.booking.lead_booker.id;
    },

    newTraveller(traveller) {
      this.showAddTravellerDialog = false;
      this.$emit("travellerAdded", traveller);
    },

    addTraveller() {
      this.showAddTravellerDialog = true;
    },

    removeTraveller(traveller) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          bookingApi
            .removeTraveller({ booking: this.booking, traveller: traveller })
            .then(response => {
              this.$emit("travellerRemoved", traveller);
            });
        }
      });
    },

    setDetailsComplete(traveller) {
      bookingApi.updateTraveller({
        booking: this.booking,
        traveller: traveller
      });
    },

    departurePriceOveride(traveller, evt) {
      bookingApi
        .updateTraveller({ booking: this.booking, traveller: traveller })
        .then(response => {
          this.$emit("bookingChanged", this.booking);

          this.$notify({
            timeout: 2500,
            message: "Departure Price Updated",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
    },

    addExtra(traveller) {
      this.selectedTraveller = traveller;
      this.showExtrasDialog = true;
    },

    newExtra(data) {
      this.selectedTraveller.extras.push(data.extra);
      this.showExtrasDialog = false;
      this.$emit("bookingChanged", this.booking);
    },

    extraRemoved(traveller, extra) {
      bookingApi
        .removeTravellerExtra({
          booking: this.booking,
          traveller: traveller,
          extra: extra
        })
        .then(response => {
          traveller.extras = _filter(traveller.extras, function(el) {
            return el.id !== extra.id;
          });

          this.$emit("bookingChanged", this.booking);
        });
    },

    extraUpdated(traveller, extra) {
      bookingApi
        .updateTravellerExtra({
          booking: this.booking,
          traveller: traveller,
          extra: extra
        })
        .then(response => {
          this.$emit("bookingChanged", this.booking);
        });
    },

    ticketSelected(traveller, ticket) {
      if (traveller.ticket?.id !== ticket.id) {
        traveller.ticket = ticket;
        traveller.departure_price = ticket.prices[this.booking.currency];
        bookingApi
          .assignTravellerTicket({ booking: this.booking, traveller, ticket })
          .then(response => {
            this.$emit("bookingChanged", this.booking);
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#traveller-header {
  border-bottom: 1px solid #00bcd4;
  margin-bottom: 1em;
}

.traveller {
  border-bottom: 1px solid #00bcd4;
  margin-bottom: 1em;
  padding-bottom: 1em;

  .personal {
    padding-bottom: 1em;
  }

  .traveller-name {
    font-weight: bold;
    font-size: 1.2em;
  }

  .booking-price {
    margin-top: 1em;
  }

  .remove-traveller {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 0.85em;
    margin-top: 1em;

    .md-icon {
      font-size: 18px !important;
      color: #f44336;
    }
  }

  .price-info {
    font-size: 15px !important;
  }
}
.extras {
  .md-layout-item {
    padding: 0px;
  }
  h6 {
    margin-bottom: 0;
    margin-top: 0.9em;
  }
  .extra {
    .options {
      margin: 13px 5px;
      padding: 0px 10px;

      li {
        list-style-type: none;
      }
    }
  }
}
</style>
